module.exports = __webpack_public_path__ + "img/logo-for-logout.ee8fbb5c.svg";